module.exports = require("./fr-CG.d.ts");